import { PAGE_CACHE_HEADERS } from "@/lib/ssrCache";
import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute } from "@tanstack/react-router";
import PressureWasherProduct from "@/pages/PressureWasherProduct";
import { redirectIfPruned } from "@/lib/prunedRedirect";

export const Route = createFileRoute("/pressure-washers/$slug")({
  beforeLoad: async ({ params }) => {
    await redirectIfPruned("pressure-washers", params.slug);
    await ensureExists("pressure_washers", params.slug);
  },
  component: PressureWasherProduct,
  headers: () => PAGE_CACHE_HEADERS,
  head: ({ params }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/pressure-washers/${params.slug}`;
    return {
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});
